import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCodeBookImportPageQueryVariables = Types.Exact<{
  importId: Types.Scalars['uuid']['input'];
  pageNumber: Types.Scalars['Int']['input'];
}>;


export type GetCodeBookImportPageQuery = { __typename?: 'query_root', code_book_import_pages: Array<{ __typename?: 'code_book_import_pages', id: any, page_number: number, lines: any, overrides: any, edited_at?: any | null }> };


export const GetCodeBookImportPageDocument = gql`
    query getCodeBookImportPage($importId: uuid!, $pageNumber: Int!) {
  code_book_import_pages(
    where: {import_id: {_eq: $importId}, page_number: {_eq: $pageNumber}}
  ) {
    id
    page_number
    lines
    overrides
    edited_at
  }
}
    `;

/**
 * __useGetCodeBookImportPageQuery__
 *
 * To run a query within a React component, call `useGetCodeBookImportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeBookImportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeBookImportPageQuery({
 *   variables: {
 *      importId: // value for 'importId'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetCodeBookImportPageQuery(baseOptions: Apollo.QueryHookOptions<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables> & ({ variables: GetCodeBookImportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>(GetCodeBookImportPageDocument, options);
      }
export function useGetCodeBookImportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>(GetCodeBookImportPageDocument, options);
        }
export function useGetCodeBookImportPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>(GetCodeBookImportPageDocument, options);
        }
export type GetCodeBookImportPageQueryHookResult = ReturnType<typeof useGetCodeBookImportPageQuery>;
export type GetCodeBookImportPageLazyQueryHookResult = ReturnType<typeof useGetCodeBookImportPageLazyQuery>;
export type GetCodeBookImportPageSuspenseQueryHookResult = ReturnType<typeof useGetCodeBookImportPageSuspenseQuery>;
export type GetCodeBookImportPageQueryResult = Apollo.QueryResult<GetCodeBookImportPageQuery, GetCodeBookImportPageQueryVariables>;